import React from 'react'
import { Navigate } from 'react-router';
import { useRouterProps } from '../../utils/withRouter';
import { connect } from 'react-redux';
import PrivateRoute from './PrivateRoute'
import { lazyWithPreload } from '../../utils/lazyLoading';
import LoaderSVG from '../../assets/images/loader_animate.gif';
import { isLoggedIn } from '../../utils/session';

// Keep a stable page type across store updates.
const Restricted = lazyWithPreload(() => import("../../components/Restricted"));

// An unresolved profile needs Login, even with a token. It is not a logout: the token and
// keepmeLogged both stay (removing keepmeLogged made the next boot end a remembered member's session,
// PANEL-1633). App carries the reauthenticate flag to Login.
const LoginRedirect = ({ location }) => <Navigate to="/" replace state={{ from: location, reauthenticate: true }} />;

const RestrictedRoute = ({restricted, userData, isLoading, ...rest }) => {
  const routerProps = useRouterProps();
  if (!isLoggedIn()) return <LoginRedirect location={routerProps.location} />;
  if (!(userData && userData.user)) {
    if (isLoading) return <div className="pageLoaderUpdated" role="status"><img src={LoaderSVG} alt=""/>Loading..</div>;
    return <LoginRedirect location={routerProps.location} />;
  }
  if(restricted || !userData.user.has_affiliates) return <Restricted {...routerProps} />;
  return <PrivateRoute {...rest} />;
}

const mapStateToProps = (state) => ({
  userData: state.auth && state.auth.userData,
  isLoading: state.auth && state.auth.isLoading
})

export default connect(mapStateToProps, {})(RestrictedRoute);
